import { createApp } from 'vue'
import App from './App.vue'
import { BootstrapVue3 } from "bootstrap-vue-3";
import router from './router/router';
import ElementPlus from 'element-plus'
import { createPinia } from 'pinia';
import VueCalendarHeatmap from 'vue3-calendar-heatmap'
import i18n from '@/assets/js/i18n'
import store from './store';
// import { VueReCaptcha } from 'vue-recaptcha-v3';

import "bootstrap-vue-3/dist/bootstrap-vue-3.css";
import "bootstrap/dist/css/bootstrap.css";
import '@/assets/css/style-starter.css';
import 'element-plus/dist/index.css'
import 'leaflet/dist/leaflet.css';
import 'leaflet-draw/dist/leaflet.draw.css';
import 'animate.css';



const pinia = createPinia();
const app = createApp(App);
// 从 localStorage 中获取保存的语言，默认设置为 "en"
const savedLanguage = localStorage.getItem("selectedLanguage") || "en";
i18n.global.locale.value = savedLanguage;

// 全局混入：监听语言变化，并保存到 localStorage
app.mixin({
  watch: {
    "$i18n.locale"(newLang) {
      localStorage.setItem("selectedLanguage", newLang);
    }
  }
});

app
  .use(pinia)
  .use(router)
  .use(BootstrapVue3)
  .use(ElementPlus)
  .use(VueCalendarHeatmap)
  .use(i18n)
  .use(store)
  .mount("#app");